module.exports = __webpack_public_path__ + "img/1492729095.3f76a5a0.jpg";